import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, RouterEvent, NavigationEnd } from '@angular/router';
import { CatalogLauncherWizardComponent, CatalogService } from '@serengeti/serengeti-app';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ProjectService } from '../../project/service/project.service';

@Component({
  selector: 'app-service-catalog-launcher',
  templateUrl: './launcher.component.html',
  styleUrls: ['./launcher.component.scss']
})
export class ServiceCatalogLauncherComponent implements OnInit, OnDestroy {

	projectId: string;
	project: any;
	selectedTenant: any;

	routeSubscription: Subscription;
	@ViewChild('wizard', {static: false}) wizard: CatalogLauncherWizardComponent;
	
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private projectService: ProjectService,
		private catalogService: CatalogService
	) {
		this.routeSubscription = this.router.events.pipe(
			filter((event: RouterEvent) => event instanceof NavigationEnd)
		).subscribe(() => {
			this.projectId = this.route.snapshot.paramMap.get('projectId');
		
			this.projectService.get(this.projectId).subscribe((project: any) => {
				this.project = project;
				this.selectedTenant = project;
			});
		});
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		if (this.routeSubscription) {
			this.routeSubscription.unsubscribe();
		}
	}

	instanceCallback() {
		this.router.navigate(['/main', { outlets: { content: 'service/catalog/list' }}]);
	}

	onTenantSelected(selectedTenant: any) {
		this.selectedTenant = selectedTenant;
	}

	getSoftwareTemplateApps(softwareTemplates: any[], resourceTemplate: any): any[] {
		return this.catalogService.getSoftwareTemplateApps(softwareTemplates, resourceTemplate);
	}

	getSoftwareTemplate(softwareTemplates: any[], resourceTemplate: any) {
		return this.catalogService.getSoftwareTemplate(softwareTemplates, resourceTemplate);
	}

	onSoftwareConfigure($event: any) {
		this.wizard.onSoftwareConfigure($event);
	}
}
